import { Capacitor } from '@capacitor/core';
import { CAPACITOR_IMAGE_PLUGIN } from '../../../capacitor_plugins/pluginConstants';
import { isPlatformTablet } from '../../platform/utils/platformDetailsUtils';
import platformSingleton from '../../platform/platformSingleton';
import { sendImagesToCapacitor } from './sendImagesToCapacitor';

export const getOpenFullSizeImageOrNativeCarousel =
    (props: {
        elementId: string;
        dispatchNavigateToImage: (elementId: string) => void;
        dispatchGetCurrentBoardImagesForCarousel: () => Record<string, unknown>;
        deselectAll: () => void;
    }) =>
    (event: MouseEvent) => {
        event.preventDefault();

        const { elementId, dispatchNavigateToImage, dispatchGetCurrentBoardImagesForCarousel, deselectAll } = props;
        const useNativeCarousel =
            Capacitor.isPluginAvailable(CAPACITOR_IMAGE_PLUGIN) && !isPlatformTablet(platformSingleton);

        if (!useNativeCarousel) {
            dispatchNavigateToImage(elementId);
            return;
        }

        const imagesObject = dispatchGetCurrentBoardImagesForCarousel();

        sendImagesToCapacitor(imagesObject, elementId, deselectAll);
    };
